// extracted by mini-css-extract-plugin
module.exports = {"buttons":"button-row_buttons__Vp3Kc","reverse":"button-row_reverse__WhJs2"};